import DefaultLayout from '../layouts/Default.vue'
import LoginLayout from '../layouts/Login.vue'

export default {
    install(Vue) {
        Vue.component( 'f-default-layout', DefaultLayout )
        Vue.component( 'f-login-layout', LoginLayout )
    }
}